
/**
 * @internal
 */
export class PositionCoordinates {
    public w?: number;
    public yh?: number;
    public element?: HTMLElement;

    constructor(public x: number, public y: number) { }

}
